export function ComingSoon({ what }: { what: string }) {
  return (
    <div className="rounded-lg border border-dashed border-ink-200 bg-white px-8 py-16 text-center">
      <p className="text-sm font-medium uppercase tracking-wide text-ink-400">Coming soon</p>
      <h2 className="mt-2 text-lg font-semibold text-ink-900">{what}</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-ink-500">
        The API endpoints are ready. The UI for this module is next up — check back after the
        next deploy or ask about the API directly.
      </p>
    </div>
  );
}
